import { Notification, Typography, useMediaQueryContext } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { replaceCms } from "apps/commons/functions/replaceCms";
import { TextField } from "../form/TextField";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { usePropertyDescriptionPrefill } from "./usePropertyDescriptionPrefill";

const MAX_CHARACTER_LIMIT = 50000;
export const PropertyDescriptionController = () => {
    const {
        cmsData: {
            description: {
                propertyDescription,
                propertyDescriptionDescription,
                autoGeneratedContent,
                autoGeneratedContentDescription,
                errorMessageExceedCharacterLimitMobile,
                errorMessageExceedCharacterLimit,
                errorMessageMissingPropertyDescription,
                descriptionPrefill,
            },
        },
    } = useStaticDataAtomValue();
    const { name, city, state } = usePropertyDescriptionPrefill();

    const context = useMediaQueryContext();

    return (
        <VStack gap="16">
            <VStack gap="8">
                <Typography variant="heading-default">{propertyDescription}</Typography>
                <Typography variant="body-s" textColor="base.subtle">
                    {propertyDescriptionDescription}
                </Typography>
            </VStack>
            <Notification
                intent="notice"
                title={autoGeneratedContent}
                description={autoGeneratedContentDescription}
                asset={{
                    id: "fill.symbol.ai-generated",
                }}
            />
            <TextField
                type="textarea"
                label={propertyDescription}
                field="propertyDescription"
                validateOnChange
                defaultValue={replaceCms(descriptionPrefill, name, city, state)}
                rules={{
                    required: errorMessageMissingPropertyDescription,
                    validate: {
                        exceed: (v) =>
                            v.length < MAX_CHARACTER_LIMIT ||
                            replaceCms(
                                !context ? errorMessageExceedCharacterLimitMobile : errorMessageExceedCharacterLimit,
                                v.length,
                                MAX_CHARACTER_LIMIT,
                            ),
                    },
                }}
                dataElementName="property-description"
            />
        </VStack>
    );
};
